module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta2.de3770c4.jpg";